import { ReactNode } from 'react';

import qs from 'qs';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useMount, useUpdateEffect } from 'react-use';

import { useQuery } from 'hooks';
import { consumeAuthorizationCode } from 'store/oauth/service';
import { Loading } from 'components/Fetch';
import { useAppSelector } from 'hooks';

import { AuthError } from '.';

interface IPatientWrapperProps {
  content: ReactNode;
}

const PatientWrapper = ({ content }: IPatientWrapperProps) => {
  const dispatch = useDispatch();
  const query = useQuery();
  const navigate = useNavigate();
  const oauthError = useAppSelector((state) => state.oauth.error);
  const oauthLoading = useAppSelector((state) => state.oauth.loading);
  const accessToken = useAppSelector((state) => state.oauth.data?.access_token);

  useMount(() => {
    if (query.authorizationCode) {
      dispatch(consumeAuthorizationCode(query.authorizationCode));
    }
  });

  useUpdateEffect(() => {
    if (query.authorizationCode && accessToken) {
      delete query.authorizationCode;
      navigate(`${window.location.pathname}?${qs.stringify(query)}`);
    }
  }, [accessToken]);

  return (
    <div className="patient-background-light">
      {oauthLoading ? <Loading /> : oauthError ? <AuthError /> : content}
    </div>
  );
};

export default PatientWrapper;
